var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFootersearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.545,
    height: 15.549,
    viewBox: "0 0 15.545 15.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-search",
    "data-name": "Icon ionic-ios-search",
    d: "M19.863,18.917l-4.323-4.364a6.161,6.161,0,1,0-.935.947l4.3,4.336a.665.665,0,0,0,.939.024A.67.67,0,0,0,19.863,18.917ZM10.7,15.553a4.865,4.865,0,1,1,3.441-1.425A4.835,4.835,0,0,1,10.7,15.553Z",
    transform: "translate(-4.5 -4.493)",
    fill: "#f06f00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootersearch);
export default __webpack_public_path__ + "static/media/footersearch.6ad1f26dc2b64c6f8d203de2ab3399f3.svg";
export { ForwardRef as ReactComponent };